import http from "../http/http-sritrang-family"
import http1 from "../http/http-sritrang-family1"

class OauthService {
    getAccessToken(data) {
        return http1.post('/sylogin/validatetokenapi',data);
    }
    getAuth(data){ 
        return http.post('/sylogin/auth',data);
    }
}

export default new OauthService();